/**
=========================================================
* Word Cloud Component
=========================================================

* A visualization component that displays words as sized chips,
* where size indicates frequency/importance.
*/

import { Chip, Tooltip } from '@mui/material'

import MDBox from 'components/MDBox'

export interface WordCloudItem {
	text: string
	size: number
	count: number
}

interface WordCloudProps {
	words: WordCloudItem[]
	minHeight?: number
}

function WordCloud({ words, minHeight = 200 }: WordCloudProps): JSX.Element {
	const getColor = (index: number): 'primary' | 'secondary' | 'info' | 'success' | 'warning' => {
		const colors: ('primary' | 'secondary' | 'info' | 'success' | 'warning')[] = [
			'primary',
			'info',
			'secondary',
			'success',
			'warning',
		]
		return colors[index % colors.length]
	}

	return (
		<MDBox
			display="flex"
			flexWrap="wrap"
			gap={1}
			justifyContent="center"
			alignItems="center"
			p={3}
			sx={{ minHeight }}
		>
			{words.map((item, index) => (
				<Tooltip key={index} title={`Count: ${item.count}`} arrow>
					<Chip
						label={item.text}
						color={getColor(index)}
						variant={index < 5 ? 'filled' : 'outlined'}
						sx={{
							fontSize: `${Math.max(0.7, item.size / 100)}rem`,
							height: 'auto',
							padding: `${Math.max(4, item.size / 20)}px`,
							fontWeight: index < 10 ? 'bold' : 'normal',
						}}
					/>
				</Tooltip>
			))}
		</MDBox>
	)
}

export default WordCloud
